import Dropzone from 'react-dropzone';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
import { useFormikContext } from 'formik';

import Card from 'Lib/components/common/Card';
import { deleteFileHandler, dropHandler } from 'Lib/components/files/helpers';
import { ShowFiles } from 'Lib/components/files/utils';
import useNotify from 'Lib/hooks/useNotify';
import fileSizeValidator from 'Lib/utilities/fileSizeValidator';


const VerificationDocuments = ({ onUploadFile, onDelete, section }) => {
    const { toastError } = useNotify();
    const form = useFormikContext();
    const { setFieldValue, values } = form;
    const { requiredCount, message, name: fieldName, docsForSection } = section;
    const formVals = values[fieldName] ?? {};
    const { filePreviews = [], fileIDs = [], fileNames = [] } = formVals;

    const verificationData = values[docsForSection] ?? {};

    const skipped = verificationData.skipVerification ?? false;

    // Only want to show the documents upload if it is docs only (i.e. Plaid verification
    // is not enabled) or applicant opted out of verification
    if (!section.docsOnly && !skipped) {
        return null;
    }

    const setFileNames = vals => {
        setFieldValue(`${fieldName}.fileNames`, vals);
    };

    const setFileIDs = vals => {
        setFieldValue(`${fieldName}.fileIDs`, vals);
    };

    const setFilePreviews = files => {
        setFieldValue(
            `${fieldName}.filePreviews`,
            // Convert the File object given in filePreview to object so that it's serializable and will work
            // when application is reloaded
            files.map(({ filePreview: preview, ...rest }) => {
                return {
                    ...rest,
                    filePreview: { path: preview.path, name: preview.name, size: preview.size, type: preview.type }
                };
            })
        );
    };

    const handleUpdateFiles = files => {
        setFieldValue(
            `${fieldName}.docs`,
            files.map(id => ({ fileID: id }))
        );
    };

    const onAttachFile = files => {
        dropHandler(
            files,
            {
                formObject: form,
                filePreviews,
                fileIDs,
                fileNames,
                config: {},
                callback: handleUpdateFiles,
                onUploadFile,
                setFileNames,
                setFilePreviews,
                setFileIDs
            },
            toastError
        );
    };

    const handleDelete = (file, index) => {
        deleteFileHandler(file, index, {
            fileNames,
            fileIDs,
            filePreviews,
            callback: handleUpdateFiles,
            onDelete,
            setFileNames,
            setFileIDs,
            setFilePreviews
        });
    };

    const renderNumRequired = numRequired => {
        if (numRequired == 0) {
            return null;
        }

        const documents = numRequired > 1 ? 'documents' : 'document';

        return `${numRequired} ${documents} required`;
    };

    return (
        <Card title="Verification Documents">
            <FroalaEditorView model={message} />
            <span style={{ color: 'rgb(128, 128, 128)' }}>{renderNumRequired(requiredCount)}</span>
            <Dropzone onDrop={onAttachFile} validator={fileSizeValidator} className="image-uploader">
                {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps({ className: 'dropzone' })} className="image-uploader">
                        Drag files here to upload
                        <br />
                        (or click to open dialog)
                        <input {...getInputProps()} />
                    </div>
                )}
            </Dropzone>
            <ShowFiles filePreviews={filePreviews} handleDelete={handleDelete} />
        </Card>
    );
};

export default VerificationDocuments;
